import { type Routes } from '@angular/router';
import { authGuard, guestGuard } from '@my-sport-app/domain';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/home',
    pathMatch: 'full'
  },
  {
    path: 'home',
    canActivate: [authGuard],
    loadComponent: () => import('./features/home/home.component').then(m => m.HomeComponent)
  },
  {
    path: 'reservar',
    canActivate: [authGuard],
    children: [
      {
        path: '',
        redirectTo: 'ciudad',
        pathMatch: 'full'
      },
      {
        path: 'ciudad',
        loadComponent: () => import('./features/court-booking/city-select/city-select.component').then(m => m.CitySelectComponent)
      },
      {
        path: 'centro',
        loadComponent: () => import('./features/court-booking/venue-select/venue-select.component').then(m => m.VenueSelectComponent)
      },
      {
        path: 'centro/:venueId/calendario',
        loadComponent: () => import('./features/court-booking/court-calendar/court-calendar.component').then(m => m.CourtCalendarComponent)
      },
      {
        path: 'exito/:bookingId',
        loadComponent: () => import('./features/court-booking/booking-success/booking-success.component').then(m => m.BookingSuccessComponent)
      },
    ]
  },
  {
    path: 'auth',
    canActivate: [guestGuard],
    children: [
      {
        path: 'login',
        loadComponent: () => import('./features/auth/login/login.component').then(m => m.LoginComponent)
      },
      {
        path: 'register',
        loadComponent: () => import('./features/auth/register/register.component').then(m => m.RegisterComponent)
      },
      {
        path: 'forgot-password',
        loadComponent: () => import('@my-sport-app/cdk').then(m => m.BoAuthForgotPasswordComponent)
      },
      {
        path: 'reset-password',
        loadComponent: () => import('./features/auth/reset-password/reset-password.component').then(m => m.ResetPasswordComponent)
      },
      {
        path: 'verify',
        loadComponent: () => import('./features/auth/verify/verify.component').then(m => m.VerifyComponent)
      },
      {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full'
      }
    ]
  },
  {
    path: 'profile',
    canActivate: [authGuard],
    loadComponent: () => import('./features/user-profile/profile/profile.component').then(m => m.ProfileComponent)
  },
  {
    path: 'mis-reservas',
    canActivate: [authGuard],
    loadComponent: () => import('./features/my-reservations/my-reservations.component').then(m => m.MyReservationsComponent)
  },
  {
    path: 'payments',
    // R5: confirmation route is deliberately unguarded — deep link entry
    // from Wompi redirect MUST work without JWT so the mobile app can
    // render confirmation after appUrlOpen interception.
    children: [
      {
        path: 'confirmation/:bookingId',
        loadComponent: () => import('./features/payments/confirmation/confirmation.component').then(m => m.PaymentConfirmationComponent)
      },
    ]
  },
  {
    path: 'terms',
    loadComponent: () => import('./shared/components/legal/terms/terms.component').then(m => m.TermsComponent)
  },
  {
    path: 'privacy',
    loadComponent: () => import('./shared/components/legal/privacy/privacy.component').then(m => m.PrivacyComponent)
  },
  {
    path: 'unauthorized',
    loadComponent: () => import('./shared/components/unauthorized/unauthorized.component').then(m => m.UnauthorizedComponent)
  },
  {
    path: '**',
    loadComponent: () => import('./shared/components/not-found/not-found.component').then(m => m.NotFoundComponent)
  }
];